import { defineStore } from 'pinia'

export const useUsersListStore = defineStore({
    id: 'usersList',

    state () {
        return {
            length: 0,
            users: [],
            title: '',
            id: null,

            loading: false,
            params: null,
            url: null,
            searchTerm: ''
        }
    },


    actions: {
        update (payload) {
            if (!payload.url) return;

            this.loading = true;
            this.searchTerm  = '';
            this.url     = payload.url;
            this.params  = payload.params;
            this.id      = payload.id;
            this.title   = payload.title;
            this.users   = [];

            this.$nuxt.$modalityStore.openModal({type: 'drawer', name: 'usersList'});

            let params = Object.assign({limit: 50}, payload.params);

            this.$nuxt.$axios.$get(this.url, {
                params,
                progress: false
            })
            .then(data => {
                if (data) {
                    this.users = data.users;
                    this.length = data.length;
                }

                this.loading = false;
            })
            .catch(err => {
                console.error(err);
                this.loading = false;
            });
        },

        load () {
            if (this.loading) return ;
            let length = this.length || 0;
            if (length <= this.users.length) return;

            this.loading = true;

            let params = Object.assign(
                {
                    skip: this.users.length,
                    search: this.search
                },
                this.params
            );

            this.$nuxt.$axios.$get(this.url, {
                params,
                progress: false
            })
            .then(data => {
                if (data) this.users.push(...data.users); 
                this.loading = false;
            })
            .catch((err) => {
                console.log(err)
                this.loading = false;
            });
        },

        search (search) {
            if (this.loading) return;

            this.loading = true;
            this.searchTerm = search;

            let params = Object.assign({skip: 0, search}, this.params);

            this.$axios.$get(this.url, {
                params,
                progress: false
            })
            .then(data => {
                if (data) this.users = data.users;
                this.loading = false;
            })
            .catch((err) => {
                console.log(err)
                this.loading = false;
            });
        }
    }
})
